export const PROFILE_COMPLETION_NOTIFICATION_ID = 'profile-completion-reminder';
const LEGACY_PROFILE_COMPLETION_IDS = new Set([
  'profile-completion-reminder',
  'sys:profile-completion',
]);
export const PROFILE_REMINDER_DISMISSED_KEY = 'profile_completion_reminder_dismissed';
export const PROFILE_COACH_MARK_DISMISSED_KEY = 'profile_completion_coach_dismissed';
export const PROFILE_COACH_MARK_AUTO_HIDE_MS = 60000;

export function getStoredUserDetails() {
  try {
    const raw = sessionStorage.getItem('userDetails');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function isMobileNumberMissing(userDetails) {
  if (!userDetails || typeof userDetails !== 'object') {
    return false;
  }
  const phone = userDetails.phone ?? userDetails.phoneE164 ?? '';
  return String(phone).trim() === '';
}

export function isProfileCompletionReminderDismissed() {
  return sessionStorage.getItem(PROFILE_REMINDER_DISMISSED_KEY) === 'true';
}

export function dismissProfileCompletionReminderForSession() {
  sessionStorage.setItem(PROFILE_REMINDER_DISMISSED_KEY, 'true');
}

export function buildProfileCompletionNotification() {
  const message =
    'Your mobile number is missing. Please update your profile to improve account security and communication.';

  return {
    id: PROFILE_COMPLETION_NOTIFICATION_ID,
    notificationId: PROFILE_COMPLETION_NOTIFICATION_ID,
    title: 'Complete Your Profile',
    body: message,
    message,
    type: 'profile_completion',
    notificationType: 'profile_completion',
    read: false,
    isRead: false,
    priority: 'high',
    timestamp: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    metadata: {
      isSystemReminder: true,
      profilePath: '/profile',
    },
    data: {
      isSystemReminder: true,
      profilePath: '/profile',
    },
  };
}

export function isProfileCompletionNotification(notification) {
  const id = String(notification?.notificationId ?? notification?.id ?? '');
  return LEGACY_PROFILE_COMPLETION_IDS.has(id);
}

export function isProfileCompletionCoachDismissed() {
  return sessionStorage.getItem(PROFILE_COACH_MARK_DISMISSED_KEY) === 'true';
}

export function dismissProfileCompletionCoachForSession() {
  sessionStorage.setItem(PROFILE_COACH_MARK_DISMISSED_KEY, 'true');
}

function normalizeRoutePath(pathname) {
  const path = String(pathname || '').split('?')[0].replace(/\/+$/, '') || '/';
  return path;
}

const STATIC_DASHBOARD_ROUTES = new Set([
  '/admin',
  '/admin/dashboard',
  '/agent',
  '/agent/dashboard',
  '/portal',
  '/portal/dashboard',
  '/portal/home',
  '/portal/index',
  '/super-admin',
  '/super-admin/dashboard',
  '/developerdashboard',
  '/integration-dashboard',
  '/home',
]);

export function isDashboardRoute(pathname, menuData) {
  const path = normalizeRoutePath(pathname);
  if (STATIC_DASHBOARD_ROUTES.has(path)) {
    return true;
  }

  if (!Array.isArray(menuData)) {
    return false;
  }

  for (const module of menuData) {
    const screens = module?.submenu || [];
    for (const screen of screens) {
      if (!screen?.isDashboard || !screen?.routing) {
        continue;
      }
      if (path === normalizeRoutePath(screen.routing)) {
        return true;
      }
    }
  }

  return false;
}

export function shouldShowProfileCompletionCoachMark() {
  const details = getStoredUserDetails();
  if (!details) {
    return false;
  }
  if (!isMobileNumberMissing(details)) {
    return false;
  }
  return true;
}
